import {useEffect, useState} from "react";

export function useScrollUp() {
    const [status, setStatus] = useState(undefined);
    useEffect(() => {
        window.scrollTo(0, 0);
        setStatus('ok');
    }, []);
    return {status}
}